













import { Component, Vue } from 'vue-property-decorator';

const commonConfig = require('../../../config/index');

@Component({
  name: 'JdRegisterAgreement'
})

export default class JdRegisterAgreement extends Vue {
  cdnBaseUrl = commonConfig.CDN_URL;

  created() {
    document.title = '注册协议';
  }
}
